import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pl-4" }
const _hoisted_2 = { class: "pl-4" }

import ValidationErrors from '@/components/Common/ValidationErrors';
import { reactive, watch, ref } from 'vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OperationOfficeNameForm',
  props: {
    operationOfficeName: {},
    operationOfficeNameKana: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['inputValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const name = ref('');
const kana = ref('');
const data = reactive({
  operation_office_name: '',
  operation_office_name_kana: '',
});

const unwatchName = watch(
  () => props.operationOfficeName,
  (propsOfficeName) => {
    name.value = propsOfficeName;
    unwatchName();
  }
);
const unwatchKana = watch(
  () => props.operationOfficeNameKana,
  (propsOfficeNameKana) => {
    kana.value = propsOfficeNameKana;
    unwatchKana();
  }
);

watch(name, () => {
  data.operation_office_name = name.value;
  emit('inputValue', data);
});
watch(kana, () => {
  data.operation_office_name_kana = kana.value;
  emit('inputValue', data);
});

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_1, [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.operationOffices.operationOfficeName')), 1),
              _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
            ])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 10 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ValidationErrors), {
              messages: __props.errors?.operation_office_name
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: name.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  maxlength: "255",
                  error: __props.errors?.operation_office_name?.length ?? 0 > 0
                }, null, 8, ["modelValue", "error"])
              ]),
              _: 1
            }, 8, ["messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 2 : 3
        }, {
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.operationOfficeNameKana')), 1),
              _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
            ])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, {
          cols: __props.windowInnerWidth > 800 ? 10 : 9
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ValidationErrors), {
              messages: __props.errors?.operation_office_name_kana
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: kana.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((kana).value = $event)),
                  maxlength: "255",
                  error: __props.errors?.operation_office_name_kana?.length ?? 0 > 0
                }, null, 8, ["modelValue", "error"])
              ]),
              _: 1
            }, 8, ["messages"])
          ]),
          _: 1
        }, 8, ["cols"])
      ]),
      _: 1
    })
  ], 64))
}
}

})